import Input from '../../components/Input';
import Select from '../../components/Select';
import translateLabel from '../../helpers/translateLabel';
import mandatoryFields from '../../configs/seatGroup';

export default function getSeatGroupFormInput({
    name,
    register,
    control,
    error,
    disabled,
    index,
    sectors,
}) {
    if (name === 'sector_id') {
        return (
            <Select
                key={index}
                name={name}
                label={translateLabel(name.replace('_id', ''))}
                options={sectors.map((sector) => {
                    return { value: sector.id, label: sector.title };
                })}
                control={control}
                error={error}
                disabled={disabled}
                noOptionMsg="No sectors"
                isRequired={mandatoryFields.find((field) => (field === name ? true : false))}
                isClearable
            />
        );
    } else {
        return (
            <Input
                key={index}
                label={translateLabel(name)}
                name={name}
                type="text"
                {...register(name, {
                    required: mandatoryFields.find((field) => (field === name ? true : false)),
                })}
                error={error}
                disabled={disabled}
            />
        );
    }
}
